/* eslint-disable react/require-default-props */
/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * SearchBox
 *
 * @file SearchBox.jsx
 * @author Mohamed yasar arabath M
 * @since 1.0.0
 */

import React from 'react';
import PropTypes from 'prop-types';
import { TextField, InputAdornment, makeStyles } from '@material-ui/core';
import Icon from '../icons/Icon';
import mixins from '../../assets/styles/mixins.scss';

const useStyles = makeStyles(() => ({
  inputRoot: {
    display: 'flex',
    padding: '12px',
    gap: '12px',
    border: `1px solid ${mixins.amethyst}`,

    '&:hover': {
      boxShadow: `0px 0px 0px 4px ${mixins.amethystLightColor}`
    },
    '&:active': {
      border: `1px solid ${mixins.amethystColorV2}`
    }
  },
  root: {
    '& .MuiOutlinedInput-root': {
      borderRadius: 6
    },
    width: '100%',
    margin: 'auto'
  },
  input: {
    padding: 0,
    color: mixins.greyScaleColor,
    fontFeatureSettings: '\'liga\' off',
    fontFamily: mixins.fontFamilyPlusSans,
    fontSize: 14,
    fontStyle: 'normal',
    fontWeight: mixins.fontWeight500,
    lineHeight: '22px',
    minHeight: 22,

    '&::placeholder': {
      color: mixins.greyScaleColor,
      opacity: 1,
      fontFeatureSettings: '\'liga\' off',
      fontFamily: mixins.fontFamilyPlusSans,
      fontSize: 14,
      fontStyle: 'normal',
      fontWeight: mixins.fontWeight500,
      lineHeight: '22px'
    }
  },
  inputAdornedEnd: {
    width: 24,
    height: 24,
    margin: 0,

    '& svg': {
      width: 18,
      height: 18
    }
  },
  notchedOutline: {
    border: 'none !important',
    borderWidth: '1px !important'
  }
}));

export default function SearchBox({ value, onChange, placeholder }) {
  const classes = useStyles();

  return (
    <TextField
      className={classes.root}
      placeholder={placeholder}
      variant="outlined"
      value={value}
      onChange={(e) => onChange && onChange(e.target.value)}
      InputProps={{
        classes: {
          root: classes.inputRoot,
          input: classes.input,
          notchedOutline: classes.notchedOutline
        },
        endAdornment: (
          <InputAdornment position="end" className={classes.inputAdornedEnd}>
            <Icon name="SearchIcon" />
          </InputAdornment>
        )
      }}
      fullWidth
    />
  );
}

SearchBox.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string
};
